import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RoomTable from './Room/roomTable';
import PageHeader from './PageHeader';
import { Breadcrumb } from 'react-bootstrap';

// Wrapper page to expose Rooms as its own nested route instead of in-place modal/state inside Properties
const RoomsPage: React.FC = () => {
  const navigate = useNavigate();
  const { rmcId, clientId, propertyId } = useParams<{ rmcId: string; clientId: string; propertyId: string }>();
  const loc = useLocation();
  const { state } = loc as { state?: any };

  const propertyName: string | undefined = state?.propertyName;
  const proposalId: number = state?.proposalId || 0;
  const clientPropertyMappingId: number = state?.clientPropertyMappingId;
  const userRole = useSelector((s: any) => s.auth.userRole) ?? '';
  const isAdmin = userRole === 'Administrator';
  const clientName: string | undefined = state?.clientName;

  const goBack = () => {
    if (rmcId && clientId) {
      navigate(`/rmc/${rmcId}/clients/${clientId}/properties`, { state: { rmcId, clientId, clientName } });
    } else {
      navigate('/properties');
    }
  };

  return (
    <div className="content">
      <div style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-2">
          <nav aria-label="breadcrumb">
            <Breadcrumb className="mb-0" style={{ background: 'transparent' }}>
              <Breadcrumb.Item href="/admin/dashboard">Admin</Breadcrumb.Item>
              <Breadcrumb.Item href="/admin/property">Properties</Breadcrumb.Item>
              <Breadcrumb.Item active>{propertyName ?? `Property #${propertyId}`}</Breadcrumb.Item>
              <Breadcrumb.Item active>Rooms</Breadcrumb.Item>
            </Breadcrumb>
          </nav>
        </div>
      </div>
      <PageHeader
        showBackButton={true}
        backTo={loc.pathname.startsWith('/admin') ? '/admin/property' : '/properties'}
        title={`Rooms - ${propertyName ?? `Property #${propertyId}`}`}
      />
      <div className="content-body" style={{ paddingTop: 0 }}>
        <div className='container mt-3'>
          <div className="row shadow">
            <div className="col-md-12 mb-3">
              <RoomTable
                clientPropertyMappingId={Number(clientPropertyMappingId)}
                proposalId={proposalId}
                propertyId={Number(propertyId)}
                propertyName={propertyName ?? 'Property'}
                onBack={goBack}
                hideCreateButton={!isAdmin}
                readOnlyMode={!isAdmin}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomsPage;
